import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.js";
import Layout from '../components/layout';
import SEO from '../components/seo';
import ActionCard from '../components/action-card';
import ActionList from '../components/action-list';
import data from '../data/home-actions';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Home" keywords={['moringa', 'organic', 'standard']} mdxType="SEO" />
    <h1>{`Who We Are`}</h1>
    <p>{`The Caribbean Organic Moringa Standard (COMS) is an element of the agricultural
innovation, carbon mitigation, and export quality adjunct of the 0001 Caribbean
Regional Initiative. `}</p>
    <p>{`As part of a sub-programmatic focus on native and adapted plants, modelled sustainable
outcomes include increased entrepreneurship, improved national health, biophilia
awareness, and increased FDI. Also, potential indirect outcomes include greening,
hardscape/heat island reduction in urban areas, and improved drainage. This concept
could not have been possible without the moringa research and publications of
Mr. Mozart Adevu, Dr Armelle de Saint Sauveur, Mr. Godfred Dosu, and Dr Mélanie Broin, who
authored the Ghanaian standard, the foundation for this work. `}</p>
    <p>{`We would like to acknowledge the support of evolveˣ, Agency Carbon/Green, and SustainT&T,
with financial assistance from The Resilience Fund and the BAF. The COMS project has been
created to drive technical engagement from the Centre for the Development of
Enterprise (CDE), CROSQ and CARDI, as well as financial support from the IADB.`}</p>
    {
      /* content within this section will eventuall be replaced
          by card components whenever available */
    }
    <section>
      <ActionList mdxType="ActionList">
     <ActionCard content={data.certification} mdxType="ActionCard" />
     <ActionCard content={data.invest} mdxType="ActionCard" />
     <ActionCard content={data.learn} mdxType="ActionCard" />
      </ActionList>
    </section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      